import { lazy } from "react";
import { build } from "../../tools/ConfigBuilder";

export default build([
	{
		path: "/profile/assets",
		component: lazy(() => import("./AssetsPage")),
	},
]);
